import { CommandResult, PublicAmorgUser } from '../amorg-common'
import { apiPath } from "./../amorg-common";
import { errorCodes } from '../amorg-common'
import { queryAuthWrapper } from './serverApiHelpers';

export const authPath = `${apiPath}/auth`;

export const login = async (siteIdOrLoginName:string, email:string, password:string):Promise<CommandResult> => {
    const response = await fetch(`${authPath}/login`,
    {
        method:'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json'
        },
        body: 
            JSON.stringify({
                siteIdOrLoginName,
                email,
                password
            })
    });
    
    if(response.status === 200)
        return CommandResult.succeeds();
    else if([400,401,403].find(s => s === response.status) !== undefined)
        return CommandResult.fails((await response.text()) as errorCodes);
    else
        return CommandResult.fails('client_error')
}

export const refresh = async ():Promise<CommandResult> => {
    const response = await fetch(`${authPath}/refresh`,
    {
        method:'GET',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if( response.status === 200){
        return CommandResult.succeeds();
    } else {
        return CommandResult.fails('client_refresh_failed');
    }
}

export const logout = async ():Promise<void> => {
    await fetch(`${authPath}/logout`,
    {
        method:'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export const getActiveUser = async (): Promise<PublicAmorgUser | null> =>
    queryAuthWrapper(`${authPath}/activeuser`);